// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__1UF6D"};